import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect, useHistory } from 'react-router-dom';
import { Button } from 'src/components/atoms';
import { NavbarVariantEnum } from 'src/types';
import { useRedirect } from '../../../hooks';
import MobileBackButton from '../MobileBackButton';
import PublicReportDetails from '../PublicReportDetails';
import { getEvidenceButtonLabel } from './getEvidenceButtonLabel';
import {
  Bottom,
  Info,
  MobileOnlyWrapper,
  PublicReportCardContainer,
  TextLink,
} from './PublicReportCard.styles';

interface Props {
  style?: React.CSSProperties;
  linkToViewReport: boolean;
  organisation: string;
  reportId: string;
  category: string;
  displayId: string;
  status: string;
  created: string;
  source: string;
}

const PublicReportCard: React.FC<Props> = (props) => {
  const { t } = useTranslation();
  const history = useHistory();
  const { showRedirect, redirectTo, redirect } = useRedirect();

  const evidenceButtonLabel = getEvidenceButtonLabel(
    props.source,
    props.status,
  );

  return (
    <PublicReportCardContainer
      onClick={() => {
        history.push(
          props.linkToViewReport
            ? `/${props.organisation}/open-reporting/reports/${props.reportId}`
            : '#',
        );
      }}
      fullWidth={!props.linkToViewReport}
      style={props.style}
      variant={NavbarVariantEnum.PUBLIC}
    >
      {showRedirect && (
        <Redirect data-testid={redirectTo} to={`${redirectTo}`} push />
      )}
      {!props.linkToViewReport && (
        <MobileBackButton
          backText={'public.PublicReport.backToReports'}
          backTo={`/${props.organisation}/open-reporting/reports`}
        />
      )}
      <Info>
        <PublicReportDetails
          organisation={props.organisation}
          reportId={props.reportId}
          category={props.category}
          displayId={props.displayId}
          status={props.status}
          created={props.created}
          includeStatus
          includeButton
          evidenceButtonLabel={evidenceButtonLabel}
        />
        <MobileOnlyWrapper>
          <Button
            variant="primary"
            size="medium"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              redirect(
                `/${props.organisation}/open-reporting/messages/${props.reportId}`,
              );
            }}
            width={'calc(100% - 40px)'}
          >
            {t('public.PublicReportCard.messageCaseManager')}
          </Button>
          <Button
            variant="secondary"
            size="medium"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              redirect(
                `/${props.organisation}/open-reporting/more-evidence/${props.reportId}`,
              );
            }}
            data-testid={'add-more-evidence'}
            width={'calc(100% - 40px)'}
          >
            {evidenceButtonLabel}
          </Button>
        </MobileOnlyWrapper>

        {props.linkToViewReport && (
          <Bottom>
            <TextLink
              data-testid={'view-report'}
              to={`/${props.organisation}/open-reporting/reports/${props.reportId}`}
            >
              {t('public.PublicReportCard.viewReport')}
            </TextLink>
          </Bottom>
        )}
      </Info>
    </PublicReportCardContainer>
  );
};

export default PublicReportCard;
